import { Renderer2 } from '@angular/core';
import { fromEvent, ReplaySubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie/src/cookie.service";
export class BannerService {
    constructor(cookieService) {
        this.cookieService = cookieService;
        this.bannerHeightSubject = new ReplaySubject(1);
        this.screenSizeChange = fromEvent(window, 'resize');
    }
    getBannerHeight(renderer) {
        this.renderer = renderer || this.errorHandler('renderer');
        this.monitoringPromise =
            this.monitoringPromise ||
                new Promise((resolve, reject) => {
                    resolve(setTimeout(_ => this.startMonitoring(), 2000));
                });
        return this.bannerHeightSubject;
    }
    errorHandler(field) {
        throw new Error(`${field} is required.`);
    }
    startMonitoring() {
        const bannerElements = [
            document.getElementById('onetrust-accept-btn-handler'),
            document.getElementById('accept-recommended-btn-handler'),
            document.querySelector('.onetrust-close-btn-handler')
        ];
        bannerElements.forEach(bannerElement => this.registerHandler(bannerElement));
        if (this.checkBannerAvailability()) {
            this.bannerElement = document.getElementById('onetrust-banner-sdk');
            this.screenSizeSubscription =
                this.screenSizeSubscription ||
                    this.screenSizeChange.subscribe(_ => this.bannerHeightSubject.next(this.calculateBannerHeight()));
        }
        this.bannerHeightSubject.next(this.checkBannerAvailability() ? this.calculateBannerHeight() : 0);
    }
    registerHandler(targetElement) {
        if (targetElement) {
            this.bannerSdkAvailable = true;
            if (this.bannerIsActive()) {
                this.renderer.listen(targetElement, 'click', event => {
                    this.bannerHeightSubject.next(0);
                    this.bannerHeightSubject.complete();
                    this.screenSizeSubscription.unsubscribe();
                });
            }
        }
        else {
            this.bannerSdkAvailable = false;
        }
    }
    checkBannerAvailability() {
        return this.bannerSdkAvailable && this.bannerIsActive();
    }
    bannerIsActive() {
        return !Boolean(this.cookieService.get('OptanonAlertBoxClosed'));
    }
    calculateBannerHeight() {
        return this.bannerElement.offsetHeight;
    }
}
BannerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BannerService_Factory() { return new BannerService(i0.ɵɵinject(i1.CookieService)); }, token: BannerService, providedIn: "root" });
